<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                {{company_data.full_name}}
            </div>
            <div class="content-inner">
                <div class="btn_setting_company" @click="$router.push('/company/'+id+'/edit')">Редактировать</div>
                <div class="btn_workers_in_company" @click="$router.push('/company/'+id+'/users')">Сотрудники</div>
                <div class="btn_positions_in_company" @click="$router.push('/company/positions/'+id)">Должности</div>
                <div class="btn_positions_in_company" @click="$router.push('/company/'+id+'/events')">Мероприятия</div>
                <div class="btn_positions_in_company" @click="$router.push('/marking_list/'+id)">Оценочные ведомости</div>
                <div class="content-sub-header">Корпоративные стандарты компании</div>
                <br>
                <div class="btn_add" @click="$router.push('/company/corpstandart/'+id+'/new')">Добавить Корпоративный стандарт</div>
                <table>
                    <tr>
                        <th>Наименование</th>
                        <th>Должность</th>
                        <th>Тип профессии</th>
                        <th>Описание</th>
                        <!--<th>Дата создания</th>-->
                        <th>Статус</th>
                        <th></th>
                        <th></th>
                    </tr>
                    <tr v-for="standart in corpstandart_list" :key="standart.id">
                        <td>{{standart.name}}</td>
                        <td>{{user_positions_list[standart.position_id]}}</td>
                        <td>{{ref_type_proffession[standart.position_type_id]}}</td>
                        <td>{{standart.description}}</td>
                        <!--<td>{{standart.created_at}}</td>-->
                        <td>{{cs_status_list[standart.status_id]}}</td>
                        <td style="min-width: 300px !important;">
                            <div class="btn_for_table buttons_inline" @click="$router.push('/company/corpstandart/'+id+'/'+standart.id+'/edit')">Редактировать</div>
                            <div class="btn_for_table buttons_inline" @click="$router.push('/company/corpstandart/'+standart.id)">Перейти</div>
                            <div class="btn_for_table_delete buttons_inline" @click="delete_corpstandart(standart.id)">Удалить</div>
                        </td>
                    </tr>
                </table>

            </div>
        </div>
    </div>
</template>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Company',
    props: ['id'],
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            company_data: {},
            corpstandart_list: {},
            user_positions_list: [],
            user_positions_list_full: {},
            cs_status_full: {},
            cs_status_list: [],
            ref_type_proffession: {
                1: 'Рабочая профессия',
                2: 'ИТР'
            }
        }
    },
    methods: {
        company() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/company/'+this.id)
            .then(response => {
                this.company_data = response.data.data  
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        corpstandart() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/corpstandart/'+this.id)
            .then(response => {
                this.corpstandart_list = response.data.data  
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        user_positions() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/positions/'+this.id)
            .then(response => {
                this.user_positions_list_full = response.data.data
                let user_positions_list = response.data.data 
                let tmp_array = [] 
                user_positions_list.forEach(element => {
                    tmp_array[element.id] = element.name 
                    //console.log()
                });
                this.user_positions_list = tmp_array
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        corpstandart_statuses() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/corpstandart_status')
            .then(response => {
                this.cs_status_full = response.data.data
                let cs_status_list = response.data.data 
                let tmp_array = [] 
                cs_status_list.forEach(element => {
                    tmp_array[element.id] = element.name 
                    //console.log()
                });
                this.cs_status_list = tmp_array
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        delete_corpstandart(standart_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.delete(process.env.VUE_APP_API_URL + '/api/corpstandart/'+standart_id)
            .then(response => {
                this.operation_info = response.data.data
                this.isSuccess = true
                loader.hide()
                this.corpstandart()
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    },
    created() {
        this.user_positions()
        this.corpstandart_statuses()
        this.company()
        this.corpstandart()
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>